module.exports = __webpack_public_path__ + "media/marvelous-bio-audiogram-v1.c89f0c98.mp3";